import { render } from "./loadingcomponent.vue?vue&type=template&id=f0d2c526&scoped=true"
import script from "./loadingcomponent.vue?vue&type=script&lang=js"
export * from "./loadingcomponent.vue?vue&type=script&lang=js"

import "./loadingcomponent.vue?vue&type=style&index=0&id=f0d2c526&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d2c526"]])

export default __exports__